import { ThemeUICSSObject, spacing } from '@apia/theme';

const jsp: ThemeUICSSObject = {
  background: 'transparent',

  '.modal__main': {
    width: 'root',
  },

  '.modal__content': {
    display: 'flex',
    flexDirection: 'column',

    '& > .content': {
      maxHeight: '100%',
      overflow: 'auto',
    },

    '& > footer': {
      display: 'flex',
      gap: spacing(3),
      justifyContent: 'right',
      pt: spacing(3),
    },
  },
};

export default jsp;
